import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Layers } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const SCOPES = ["all", "parking", "regular"];

export const FloorScopeProgress = ({ projectId }) => {
  const { t } = useTranslation();
  const [scope, setScope] = useState("all");
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    setError(false); setLoading(true);
    axios.get(`/project-progress/${projectId}/floor-summary`, { params: { floor_scope: scope }, signal: controller.signal })
      .then((res) => { setData(res.data); setLoading(false); })
      .catch((e) => { if (!axios.isCancel(e)) { setError(true); setLoading(false); } });
    return () => controller.abort();
  }, [projectId, scope]);

  return (
    <div className="mt-4 pt-3 border-t border-purple-100 space-y-2" data-testid="floor-scope-progress">
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-medium text-purple-700 flex items-center gap-1"><Layers className="w-3.5 h-3.5" /> {t("floorScope.floorWork")}</span>
        <Select value={scope} onValueChange={setScope}>
          <SelectTrigger data-testid="floor-scope-select" className="h-7 w-36 text-xs rounded-sm"><SelectValue /></SelectTrigger>
          <SelectContent>
            {SCOPES.map((s) => <SelectItem key={s} value={s} data-testid={`floor-scope-option-${s}`}>{t(`floorScope.${s}`)}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {error && <p className="text-xs text-red-600" data-testid="floor-scope-error">{t("floorScope.loadFailed")}</p>}
      {loading && !error && <p className="text-xs text-slate-400" data-testid="floor-scope-loading">{t("common.loading")}</p>}
      {data && !error && !loading && (
        <>
          <div className="text-lg font-semibold tabular-nums text-purple-900" data-testid="floor-scope-percent">{data.completion_pct}%</div>
          <div className="w-full bg-purple-100 rounded-full h-1.5">
            <div className="bg-purple-500 h-1.5 rounded-full transition-[width]" style={{ width: `${data.completion_pct}%` }} />
          </div>
          <p className="text-[11px] text-slate-500" data-testid="floor-scope-detail">
            {data.total_items ? t("floorScope.detail", { done: data.completed_items, total: data.total_items, units: data.units_count }) : t("floorScope.none")}
          </p>
        </>
      )}
    </div>
  );
};
